import React, { useEffect, useState } from 'react';
import Paginacao from '../../Paginacao';
import './styles.scss';

const ResumoBoletos = ({
  tema,
  parcelasAPagarComBoleto,
  setSolicitacaoInvalida,
  contratoSelecionado,
}) => {
  const [parcelasBoletosPendentes, setParcelasBoletosPendentes] = useState([]);

  useEffect(() => {
    if (parcelasAPagarComBoleto.length > 0) {
      filtraPorBoletosPendentes();
    } else {
      setParcelasBoletosPendentes([]);
    }
  }, [parcelasAPagarComBoleto]);

  function filtraPorBoletosPendentes() {
    let resultBoletosPendentes = parcelasAPagarComBoleto.filter(
      (parc) => parc.temBoleto == true
    );

    filtraPorBoletosAgrupados(resultBoletosPendentes);
  }

  function filtraPorBoletosAgrupados(boletosPendentes) {
    let arrayBoletosPendentes = [];

    let removeDuplicados = [];

    for (let boleto of boletosPendentes) {
      if (boleto.boletoAgrupado) {
        boleto.grupoExpandido = { totalBoleto: 0, membros: [] };

        for (let i of boleto.grupoBoleto) {
          let membro = boletosPendentes.find((b) => b.numeroParcelaGeral == i);

          boleto.grupoExpandido.membros.push(membro);

          boleto.grupoExpandido.totalBoleto += membro.valorReajustado;
        }

        for (let item of boleto.grupoBoletoOutroContrato) {
          boleto.grupoExpandido.membros.push(item);

          boleto.grupoExpandido.totalBoleto += item.valorReajustado;
        }
      }
    }

    for (let bol of boletosPendentes) {
      if (
        removeDuplicados.find(
          (b) =>
            b.bancoBoleto === bol.bancoBoleto && b.seuNumero === bol.seuNumero
        ) === undefined
      )
        removeDuplicados.push(bol);
    }

    setParcelasBoletosPendentes(removeDuplicados);

    return arrayBoletosPendentes;
  }

  return (
    <div className='resumoBoletos'>
      <div
        className='centralized resumoBoletos__header'
        style={{ backgroundColor: tema.primaryColor }}
      >
        <p>Resumo dos boletos gerados</p>
      </div>

      {parcelasBoletosPendentes.length == 0 && (
        <p style={{ width: '100%', textAlign: 'center' }}>
          <b>Não há registros para exibir</b>
        </p>
      )}

      {parcelasBoletosPendentes.length > 0 && (
        <>
          <Paginacao
            parcelas={parcelasBoletosPendentes}
            tema={tema}
            tipo='boletosPendentes'
            setSolicitacaoInvalida={setSolicitacaoInvalida}
            contratoSelecionado={contratoSelecionado}
          />
        </>
      )}
    </div>
  );
};

export default ResumoBoletos;
